import { SeverityNumber } from '@opentelemetry/api-logs';
import { ExportResultCode } from '@opentelemetry/core';
import { getDefaultFlushConfig } from '../../utils';
import { ConsoleLogExporter } from '../exporters/console-exporter';
export const exportCommon = (exporter, records) => {
    return new Promise((resolve, reject) => {
        exporter.export(records, exportResult => {
            if (exportResult.code !== ExportResultCode.SUCCESS) {
                reject(exportResult.error);
            }
            resolve();
        });
    });
};
export const getCachedLogProcessorDefaults = () => ({
    errorHandler: (error) => {
        console.error('Error processing logs', error);
    },
    exporterTargets: { [SeverityNumber.UNSPECIFIED]: 'console' },
    exporters: { console: new ConsoleLogExporter() },
    flushConfig: getDefaultFlushConfig(),
    skipCache: false,
});
//# sourceMappingURL=utils.js.map